import MaterialTable from "material-table";
import React from "react";
import { connect } from "react-redux";
import { GET_PROJECT_SUPERVISOR } from "../graphql/queries";
import { useQuery } from "@apollo/client";
import { Button } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import {BiDetail} from 'react-icons/bi'
import { LinearProgress } from "@material-ui/core";
import {optionTableTask} from './OptionTable.component'

const TableTaskList = ({ columnData }) => {
  const history = useHistory();
  const { data, loading, refetch } = useQuery(GET_PROJECT_SUPERVISOR, {
    pollInterval: 1000,
  });

  if (loading) return <LinearProgress />;

  const plannerData = data.findAllProjectSupervisor
    .slice()
    .filter(({status}) => status === "done" || status === "complete" || status === "return to worker")
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map((o) => ({ ...o }));
  return (
    <div className="max-width-section m-5">

    <MaterialTable
      columns={columnData}
      data={plannerData}
      title="Project List from Worker"
      options={optionTableTask}
      components={{
        Action: props => (
          <Button
            onClick={(event) => props.action.onClick(event, props.data)}
            variant="outline-dark"
            className="mx-auto"
            style={{textTransform: 'none'}}
            size="small"
          >
            View Detail
          </Button>
        ),
      }}
      actions={[
        {
          onClick: (event, rowData) =>
          {
            history.push({
              pathname: `/dashboard/supervisor/task-list/${rowData.id}`,
            });
          }
        },
      ]}
    />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    columnData: state.spv.columnDataTask,
  };
};

export default connect(mapStateToProps, null)(TableTaskList);
